import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {Download} from 'lucide-react';


export default function DownloadReportButton(props){
  const navigate = useNavigate()
  
  useEffect(() => {
    
    // Add event listener
    //window.addEventListener('afterprint', handleAfterPrint);
    // Cleanup the event listener on component unmount
    return () => {
      //window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [navigate]); // Add navigate to the dependency array

  function handleAfterPrint(){
    //console.log('Print dialog closed, navigating away...');
    // Navigate to your specific page, e.g., '/dashboard'
    navigate(props.returnRoute);
  };


  function onDownloadReportButtonClickedEvent(event){
    //console.log("onDownloadReportButtonClickedEvent-event", event);
    event.preventDefault();
    navigate(props.targetRoute, { state: { fromPage: location.pathname }});
    // We update the document title temporarily so the PDF filename defaults correctly
    const originalTitle = document.title;
    document.title = "Innovator_Leader_Psychology_Report";
    
    //window.addEventListener('afterprint', handleAfterPrint);
    // Restore original title after the print dialog closes
    setTimeout(() => {      
        window.print();        
        document.title = originalTitle;
        }, 1000);
  }

  function handleDownload(){
    // We update the document title temporarily so the PDF filename defaults correctly
    const originalTitle = document.title;
    document.title = "Innovator_Leader_Psychology_Report";
    
    window.print();
    
    // Restore original title after the print dialog closes
    setTimeout(() => {
      document.title = originalTitle;
    }, 1000);
  };

  return (
    <div className="no-print">
      <button className="btn-element btn-h45 btn-w135 font-s12 position-rel mt-30 button-download-grid"
          onClick={onDownloadReportButtonClickedEvent} >
              <Download size={20} className="download-icon"/>
              <span className="download-text">Download Report </span> 
      </button>
    </div>
  );
};
